function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongtext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.72685 11.9647C3.47328 11.9647 3.26138 11.879 3.09114 11.7075C2.9209 11.5361 2.83519 11.3236 2.834 11.07C2.83281 10.8165 2.91852 10.6046 3.09114 10.4343C3.26376 10.2641 3.47566 10.179 3.72685 10.179H26.9411C27.1947 10.179 27.4066 10.2647 27.5768 10.4361C27.7471 10.6076 27.8328 10.8201 27.834 11.0736C27.8351 11.3272 27.7494 11.5391 27.5768 11.7093C27.4042 11.8796 27.1923 11.9647 26.9411 11.9647H3.72685ZM3.72685 4.82184C3.47328 4.82184 3.26138 4.73613 3.09114 4.5647C2.9209 4.39327 2.83519 4.18077 2.834 3.9272C2.83281 3.67363 2.91852 3.46173 3.09114 3.29149C3.26376 3.12125 3.47566 3.03613 3.72685 3.03613H26.9411C27.1947 3.03613 27.4066 3.12185 27.5768 3.29328C27.7471 3.4647 27.8328 3.6772 27.834 3.93078C27.8351 4.18435 27.7494 4.39625 27.5768 4.56649C27.4042 4.73673 27.1923 4.82184 26.9411 4.82184H3.72685Z",
    fill: "#1A4338",
    style: {
      fill: "#1A4338",
      fill: "color(display-p3 0.1020 0.2627 0.2196)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.72685 26.429C3.47328 26.429 3.26138 26.3433 3.09114 26.1719C2.9209 26.0005 2.83519 25.788 2.834 25.5344C2.83281 25.2808 2.91852 25.0689 3.09114 24.8987C3.26376 24.7285 3.47566 24.6433 3.72685 24.6433H16.2268C16.4804 24.6433 16.6923 24.729 16.8625 24.9005C17.0328 25.0719 17.1185 25.2844 17.1197 25.538C17.1209 25.7915 17.0352 26.0035 16.8625 26.1737C16.6899 26.3439 16.478 26.429 16.2268 26.429H3.72685ZM3.72685 19.2862C3.47328 19.2862 3.26138 19.2005 3.09114 19.0291C2.9209 18.8576 2.83519 18.6451 2.834 18.3916C2.83281 18.138 2.91852 17.9261 3.09114 17.7558C3.26376 17.5856 3.47566 17.5005 3.72685 17.5005H26.9411C27.1947 17.5005 27.4066 17.5862 27.5768 17.7576C27.7471 17.9291 27.8328 18.1416 27.834 18.3951C27.8351 18.6487 27.7494 18.8606 27.5768 19.0308C27.4042 19.2011 27.1923 19.2862 26.9411 19.2862H3.72685Z",
    fill: "#1A4338",
    style: {
      fill: "#1A4338",
      fill: "color(display-p3 0.1020 0.2627 0.2196)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongtext);
export default __webpack_public_path__ + "static/media/longtext.39a1a1265ada516aea3cafdcf365c5b0.svg";
export { ForwardRef as ReactComponent };